import './App.css';
import {
  BrowserRouter as Router,
  // Route,
  Switch
} from "react-router-dom";

import UserRoute from './pages/UserRoute/UserRoute';
import NonUserRoute from './pages/NonUserRoute/NonUserRoute';
import AuthProvider from './contexts/AuthProvider';
import initializeAuthentication from './firebase/firebase.init';
import Login from './pages/Home/Login/Login';
import Register from './pages/Home/Register/Register';
import Header from './pages/Shared/Header/Header';
import Collections from './pages/Collections/Collections';
import Departments from './pages/Departments/Departments';
import Subjects from './pages/Subjects/Subjects';
import Serieses from './pages/Serieses/Serieses';
import Semesters from './pages/Semesters/Semesters';
import Upload from './pages/Upload/Upload';
import Resource from './pages/Resource/Resource';
import Search from './pages/Search/Search';
import Manage from './pages/Manage/Manage';


initializeAuthentication();

function App() {
  return (
    <>
      <AuthProvider>
        <Router>
            <Header />
          <Switch>

            <NonUserRoute exact path='/'>
              <Login />
            </NonUserRoute>

            <NonUserRoute path='/register'>
              <Register />
            </NonUserRoute>

            <UserRoute exact path='/collections'>
              <Collections />
            </UserRoute>

            <UserRoute exact path='/upload'>
              <Upload />
            </UserRoute>

            <UserRoute exact path='/collections/:series'>
              <Serieses />
            </UserRoute>

            <UserRoute exact path='/collections/:series/:dept'>
              <Departments />
            </UserRoute>

            <UserRoute exact path='/collections/:series/:dept/:semester'>
              <Semesters />
            </UserRoute>

            <UserRoute exact path='/collections/:series/:dept/:semester/:subject'>
              <Subjects />
            </UserRoute>

            <UserRoute exact path='/retrieve/:link'>
              <Resource />
            </UserRoute>

            <UserRoute exact path='/manage'>
              <Manage />
            </UserRoute>

          </Switch>
        </Router>
      </AuthProvider>
    </>
  );
}

export default App;
